const prefix = "/upload";

export const UPLOAD_ENDPOINTS = {
  BASE: prefix,
  UPLOAD_SINGLE_IMAGE: `${prefix}/image`,
};

export const UPLOAD_QUERY = {
  UPLOAD_SINGLE_IMAGE: "UPLOAD_SINGLE_IMAGE",
};
